import React from "react";
import "./NutritionalTable.css";

const NutritionalTable = ({ data, isCommentPresent }) => {
  return (
    <div className="nutritional-table-container">
      <h2>Nutritional Composure</h2>
      <table className="nutritional-table">
        <thead>
          <tr>
            <th>Nutrient</th>
            <th className="nutritional-table-value">Value</th>
            {isCommentPresent && <th>Comment</th>}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.nutrient}</td>
              <td>{item.value}</td>
              {isCommentPresent && <td>{item.comment}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default NutritionalTable;
